//filter results
import {showMessage} from "./modals";
import {updateBaseUrl, updateQueryStringParameter} from "./helpers";

class FoodFilter {
    static get HIDE_ITEMS_BEFORE_LOAD() {
        return true;
    }
    static get LOAD_ALL_ITEMS() {
        return false;
    }

    constructor(container, categories, selected, currentCategory) {
        const _this = this;
        _this.container = container
        _this.filterListBlock = _this.container.find(' .filter-list')
        _this.filterPartialsBlock = _this.container.find(' .filter-partials')
        _this.filterVariablesBlock = _this.container.find(' .filter-variables')
        _this.menuCategoryDescriptionBlock = $('.js-section-description')
        _this.rootCategoryDescriptionText = $('.js-all-category-description').html()
        _this.rootRoute = _this.container.data('route')
        _this.rootSlug = _this.container.data('root-slug')
        _this.currentCategory = currentCategory
        _this.rootCategories = _this.menuCategories = categories
        _this.filters = {}
        _this.lastFilterUrl = ''

        _this.tabMenuClicked(_this.container.find('.nav-dish-tab.nav-link.active'))

        _this.container.find(' .tab_main').on('click', ' .nav-link', function () {
            _this.tabMenuClicked($(this))
        });
        _this.filterListBlock.on('click', ' div.li-emulation[data-filter-param]', function () {
            _this.filterTabClicked($(this))
        });
        _this.filterVariablesBlock.on('click', ' .js-btn-variable', function () {
            _this.variableTabClicked($(this))
        });
    }

    //show top line links
    showTabs(category, level, hidden, selectedKey, updateUrl) {
        const _this = this;
        updateUrl = updateUrl || true
        level = level || 1
        level = +(level < 1 ? 1 : level)

        if (FoodFilter.HIDE_ITEMS_BEFORE_LOAD) {
            _this.hideTabContent();
        }

        _this.initCurrentMenuFilter()
        const currentFilter = _this.getCurrentFilter();
        if ('children' in category && category.children) {
            let result = '';
            selectedKey = selectedKey || (level in currentFilter && currentFilter[level] && 'slug' in currentFilter[level] ? currentFilter[level].slug : null);
            let selectedItem = null
            if (selectedKey in category.children) {
                selectedItem = category.children[selectedKey]
            }
            for (const [key, value] of Object.entries(category.children)) {
                let otherCategoriesClassName = selectedItem || hidden ? ' d-none' : ''
                const existsItem = _this.getExistsItem(_this.filterListBlock, 'filter-param', key, level)
                let itemClasses = selectedKey === key ? ' selected' : 'selection' + otherCategoriesClassName;
                itemClasses += ' li-emulation p-1 p-md-2'
                itemClasses += value.img ? ' col-6 col-md-4 col-lg-3' : ' col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2'
                if (existsItem && existsItem.length) {
                    existsItem.removeClass('d-none selection').addClass(itemClasses).find('button, button *').removeClass('d-none')
                } else {
                    result += `
                        <div class="${itemClasses}" data-menu-tab="${_this.currentCategorySlug}" data-level="${level}" data-filter-param="${key}">
                            <button type="button" class="card-info-extend __big js-btn-variable ">
                                ` + (value.img ? `<div class="card-icon"><img src="${value.img}" alt="Icon"></div>` : '') + `
                                <p class="card-text">${value.name}</p>
                            </button>
                            <p class="card-text card-text-selection">${value.name}</p>
                        </div>`
                }
            }

            if (!!selectedItem) {
                _this.outputChildrenOrLoadItems(selectedItem, level + 1, updateUrl)
            }

            _this.filterListBlock.append(result);
        }

        updateUrl && _this.updateCurrentUrl()
    }

    tabMenuClicked(clickedItem) {
        const _this = this;
        _this.lastFilterUrl = ''
        _this.currentCategorySlug = $(clickedItem).data('route').replace(_this.rootRoute, '').replace('/', '').replace(/\?search=.*?$/, '') || 'all'

        if (FoodFilter.HIDE_ITEMS_BEFORE_LOAD) {
            _this.hideTabContent();
        }

        _this.menuCategories = {};
        if (_this.currentCategorySlug in _this.rootCategories) {
            _this.menuCategories = _this.rootCategories[_this.currentCategorySlug]
        }
        if('description' in _this.menuCategories) {
            _this.menuCategoryDescriptionBlock.html(_this.menuCategories.description)
        } else if(_this.currentCategorySlug === 'all') {
            _this.menuCategoryDescriptionBlock.html(_this.rootCategoryDescriptionText)
        } else {
            _this.menuCategoryDescriptionBlock.empty()
        }

        _this.initCurrentMenuFilter()
        //region hide items of other tab
        _this.filterListBlock.find(`:not([data-menu-tab="${_this.currentCategorySlug}"]`).addClass('d-none')
        //_this.filterPartialsBlock.find(`:not([data-menu-tab="${_this.currentCategorySlug}"]`).addClass('d-none')
        _this.filterVariablesBlock.find(`:not([data-menu-tab="${_this.currentCategorySlug}"]`).remove()
        //endregion

        if(_this.currentCategorySlug === 'all' || !('children' in _this.menuCategories)) {
            _this.loadItemsByUrl($(clickedItem).data('route'))
            return ;
        }

        let currentCategoriesSlugs = Array.from(_this.currentCategory.split('.').slice(2))
        let tmpCategories = _this.menuCategories

        for(const index in currentCategoriesSlugs) {
            const slug = currentCategoriesSlugs[index]
            if(('children' in tmpCategories) && (slug in tmpCategories.children)) {
                tmpCategories = tmpCategories.children[slug]
            } else {
                currentCategoriesSlugs.splice(+index);
                break;
            }
        }

        //region open first subcategory if it is only one
        if(
            !currentCategoriesSlugs.length &&
            !Object.keys(_this.getCurrentFilter()).length &&
            'children' in _this.menuCategories &&
            Object.keys(_this.menuCategories.children).length === 1
        ) {
            currentCategoriesSlugs.push(Object.keys(_this.menuCategories.children)[0])
        }
        //endregion

        _this.setFilters(currentCategoriesSlugs)
        _this.showTabs(_this.menuCategories, false, false, false, false)

        const currentFilter = _this.getCurrentFilter();

        const filterLevels = Array.from(Object.keys(currentFilter));
        if (filterLevels.length) {
            //_this.showTabs(_this.getCurrentCategory(), filterLevels.length)
            let itCategory = _this.menuCategories
            for (const [level, filterItem] of Object.entries(currentFilter)) {
                _this.showTabs(itCategory, level, false, filterItem.slug, false)
                if ('children' in itCategory) {
                    for (const [key, item] of Object.entries(itCategory.children)) {
                        if (key === filterItem.slug) {
                            itCategory = item
                            _this.outputChildrenOrLoadItems(item, +level + 1, false)
                        }
                    }
                }
            }
        } else {
            _this.showTabs(_this.menuCategories, 1, false, false, false)
        }

        setTimeout(() => {
            _this.updateCurrentUrl(true)
        }, 250)
    }

    //top line filter click
    filterTabClicked(clickedItem, isSelected) {
        const _this = this;
        const slug = clickedItem.data('filter-param');
        let categoryClicked = {}
        const level = +(clickedItem.data('level') || 1)
        isSelected = isSelected || clickedItem.hasClass('selection')

        if (FoodFilter.HIDE_ITEMS_BEFORE_LOAD) {
            _this.hideTabContent();
        }

        _this.initCurrentMenuFilter()

        if ('children' in _this.menuCategories && _this.menuCategories.children && slug in _this.menuCategories.children) {
            categoryClicked = {
                ..._this.menuCategories.children[slug], ...{
                    tabSlug: slug, params: []
                }
            }
        }

        _this.setFilter(slug, level)
        _this.checkTopFilters(level)

        let showVariables = true;

        if (isSelected) {
            $(clickedItem).removeClass('selection').siblings(`[data-level="${level}"][data-menu-tab="${_this.currentCategorySlug}"]`).addClass('d-none')
            _this.outputChildrenOrLoadItems(categoryClicked, level)
        } else {

            $(clickedItem).addClass('selection')
                .siblings('[data-level]')
                .filter(function () {
                    return $(this).data('level') > level;
                }).addClass('d-none')

            $(clickedItem).removeClass('d-none')

            if (level === 1) {
                showVariables = false;
                $(`[data-level="${level}"][data-menu-tab="${_this.currentCategorySlug}"]`).removeClass('d-none')
            }
            //remove last item from filter
            if (level > 1) {
                _this.checkTopFilters(level - 1)
            }

            _this.filterVariablesBlock.empty();
            _this.filterPartialsBlock.hide()
        }

        if (showVariables) {
            const category = _this.getCurrentCategory()
            //_this.showTabs(category, level + 1, slug)
            _this.outputChildrenOrLoadItems(category, isSelected ? level + 1 : level)
        } else {
            if(level <= 1) {
                _this.checkTopFilters(level - 1)
                _this.showTabs(_this.menuCategories)
            }
            _this.updateCurrentUrl()
        }
    }

    //bottom line filter click
    variableTabClicked(clickedItem) {
        const _this = this
        const slug = clickedItem.data('param')
        const title = clickedItem.data('value')
        const level = +(clickedItem.data('level') || 200)
        const tabItem = _this.filterListBlock.find(`li[data-filter-param="${slug}"][data-level="${level}"][data-menu-tab="${_this.currentCategorySlug}"]`)

        if (FoodFilter.HIDE_ITEMS_BEFORE_LOAD) {
            _this.hideTabContent();
        }

        _this.initCurrentMenuFilter()

        _this.setFilter(slug, level)

        const category = _this.getCurrentCategory()
        //_this.showTabs(category, level + 1, slug)
        _this.outputChildrenOrLoadItems(category, level + 1)

        const existsItem = _this.getExistsItem(_this.filterListBlock, 'filter-param', slug, level);
        if (existsItem.length) {
            existsItem.toggleClass('selection d-none')
        } else {
            _this.filterListBlock.append(
                `<div class="selected li-emulation p-1 p-md-2 col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2" data-menu-tab="${_this.currentCategorySlug}" data-level="${level}" data-filter-param="${slug}">
                    <button type="button" class="card-info-extend __big js-btn-variable ">
                        <p class="card-text">${title}</p>
                    </button>
                    <p class="card-text card-text-selection">${title}</p>
                </div>`
            );
        }

        for (const [level, item] of Object.entries(_this.getCurrentFilter())) {
            _this.filterListBlock.find(`[data-level="${level}"][data-filter-param="${item.slug}"][data-menu-tab="${_this.currentCategorySlug}"]`).removeClass('selection')
        }

        if (tabItem) {
            $(tabItem).removeClass('selection d-none').siblings(`[data-level="${level}"][data-menu-tab="${_this.currentCategorySlug}"]`).addClass('d-none')
        }

        _this.updateCurrentUrl()
    }

    //find inner categories or load items for the chosen
    outputChildrenOrLoadItems(category, level, updateUrl) {
        const _this = this;
        updateUrl = updateUrl || true
        _this.filterVariablesBlock.empty();
        _this.filterPartialsBlock.hide()
        level = +level

        if (FoodFilter.HIDE_ITEMS_BEFORE_LOAD) {
            _this.hideTabContent();
        }

        if('description' in category && category.description) {
            _this.menuCategoryDescriptionBlock.html(category.description)
        } else if('description' in _this.menuCategories) {
            _this.menuCategoryDescriptionBlock.html(_this.menuCategories.description)
        } else if(_this.currentCategorySlug === 'all') {
            _this.menuCategoryDescriptionBlock.html(_this.rootCategoryDescriptionText)
        } else {
            _this.menuCategoryDescriptionBlock.empty()
        }

        if ('children' in category) {
            let result = '';
            for (const [key, item] of Object.entries(category.children)) {
                const itemClasses = item.img ? 'col-6 col-md-4 col-lg-3' : 'col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2'
                result += `<div class="${itemClasses} p-1 p-md-2">
                    <button type="button" class="card-info-extend __big js-btn-variable ${!item.img ? '__not-image' : ''}" data-menu-tab="${_this.currentCategorySlug}" data-param="${key}" data-level="${level}" data-value="${item.name}">
                        ` + (item.img ? `<div class="card-icon">
                            <img src="${item.img}" alt="Icon">
                        </div>` : '') + `
                        <p class="card-text">${item.name}</p>
                    </button>
                </div>`;
            }

            _this.filterVariablesBlock.html(result);
            _this.filterPartialsBlock.show()
        } else {
            _this.loadItems()
        }

        updateUrl && _this.updateCurrentUrl()
    }

    getExistsItem(searchBlock, paramName, param, level) {
        const _this = this;
        return $(searchBlock).find(`[data-menu-tab="${_this.currentCategorySlug}"][data-${paramName}="${param}"][data-level="${level}"]`)
    }

    //load items for the current filtered category
    loadItems() {
        const _this = this

        if (FoodFilter.HIDE_ITEMS_BEFORE_LOAD) {
            _this.hideTabContent();
        }

        let categories = _this.menuCategories
        let filterUrl = _this.rootRoute + '/' + _this.currentCategorySlug
        for (const [, item] of Object.entries(_this.getCurrentFilter())) {
            filterUrl += '/' + item.slug
            if ('children' in categories && categories.children && item.slug in categories.children) {
                categories = categories.children[item.slug]
            }
        }
        _this.loadItemsByUrl(filterUrl)
    }

    loadItemsByUrl(loadUrl) {
        const _this = this
        _this.showLoader();
        const currentUri = new URL(window.location.href)
        const search = currentUri.searchParams.get('search')
        loadUrl = new URL(loadUrl)
        if(search) {
            loadUrl.searchParams.set('search', search)
        } else {
            loadUrl.searchParams.delete('search')
        }

        $.get(loadUrl, {'_': $.now()}, (ans) => {
            _this.hideLoader();
            _this.showTabContent();
            _this.container.find(' .tab-pane.active .js-live-filter-block-items').empty().append($(ans).removeClass('infinite-scroll-for-tabs js-live-filter-block-items '));
        })
    }

    //search category for the current filters
    getCurrentCategory() {
        const _this = this;
        let categories = _this.menuCategories

        _this.initCurrentMenuFilter()

        for (const [, item] of Object.entries(_this.getCurrentFilter())) {
            if ('children' in categories && categories.children && item.slug in categories.children) {
                categories = categories.children[item.slug]
            }
        }

        return categories
    }

    getCurrentFilter() {
        const _this = this;
        _this.initCurrentMenuFilter()
        return _this.filters[_this.currentCategorySlug] || {}
    }

    initCurrentMenuFilter() {
        const _this = this
        if (!(_this.currentCategorySlug in _this.filters) || !_this.filters[_this.currentCategorySlug]) {
            _this.filters[_this.currentCategorySlug] = {}
        }
    }

    setFilters(items) {
        const _this = this
        let level = 0;
        for (const item of Array.from(items)) {
            _this.setFilter(item, ++level)
        }

        let slugs = _this.rootSlug;
        for (const [, item] of Object.entries(_this.getCurrentFilter())) {
            slugs += '.' + item.slug
        }
        _this.currentCategory = slugs
    }

    //add item to filter
    setFilter(slug, level, title) {
        const _this = this;
        title = title || slug
        const prevLevel = level - 1

        _this.initCurrentMenuFilter()

        const filterItems = _this.getCurrentFilter()

        //region fix doubled level
        if (prevLevel in filterItems && filterItems[prevLevel].slug === slug && filterItems[prevLevel].title === title) {
            level = prevLevel
        }
        //endregion

        _this.filters[_this.currentCategorySlug][level] = {slug, title}
    }

    checkTopFilters(maxLevel) {
        const _this = this

        _this.initCurrentMenuFilter()

        //remove top level filters
        for (const [level,] of Object.entries(_this.getCurrentFilter())) {
            if (level > maxLevel) {
                delete _this.filters[_this.currentCategorySlug][level]
            }
        }

        //remove top level links
        _this.filterListBlock.find('[data-level]').filter(function () {
            return $(this).data('level') > maxLevel;
        }).remove()
    }

    updateCurrentUrl(forceUpdate) {
        const _this = this;
        let filterUrl = _this.rootRoute + '/' + _this.currentCategorySlug
        forceUpdate = forceUpdate || false

        _this.initCurrentMenuFilter();
        for (const [, item] of Object.entries(_this.getCurrentFilter())) {
            filterUrl += '/' + item.slug
        }
        const currentUri = new URL(window.location.href)
        const search = currentUri.searchParams.get('search')
        filterUrl = new URL(filterUrl)
        if(search) {
            filterUrl.searchParams.set('search', search)
        } else {
            filterUrl.searchParams.delete('search')
        }

        if(forceUpdate || _this.lastFilterUrl !== filterUrl) {
            _this.lastFilterUrl = filterUrl
            updateBaseUrl(filterUrl)
        }

        if (FoodFilter.LOAD_ALL_ITEMS) {
            _this.loadItems();
        }
    }

    showTabContent() {
        const _this = this;
        _this.container.find(' .tab-content').stop(true, true).fadeIn();
        _this.container.find(' .nav-link.active').trigger('filter.show.tab.content');
    }

    hideTabContent() {
        const _this = this;
        _this.container.find(' .tab-content').stop(true, true).fadeOut();
    }

    showLoader() {
        const _this = this;
        _this.container.find(' .load-tab-spinner').css('height', '100vw').append('<div class="spinner-border spinner-color"></div>');
    }

    hideLoader() {
        const _this = this;
        _this.container.find(' .load-tab-spinner').css('height', '').empty();
    }
}


$('.js-tab-food-filter').each(function () {
    new FoodFilter($(this), filterBeverages, selected, currentCategory);
});

document.addEventListener('keydown', function (e) {
    if (e.keyCode == 119) { // F8
        debugger;
    }
}, {
    capture: true
});
